import { gql } from "@apollo/client";

export const FETCH_REFERRAL_ACTIVITY = gql`
  query fetchReferralActivity(
    $filter: UserFilterInputType
    $pagination: PaginationInputType
  ) {
    fetchReferralActivity(filter: $filter, pagination: $pagination) {
      userActivities {
        id
        type
        createdAt
        User {
          username
          firstName
          lastName
          email
        }
      }
      total
    }
  }
`;